<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showVerticalFilter="panel.showVerticalFilter"
      :showSearch="panel.showSearch" :showButtons="panel.showButtons">
      <div slot="content-buttons">
        <Button _key="btnTransferCreate" title="Transferência" classIcon="fas fa-plus-circle" type="primary"
          size="small" eventName="transferCreate" :clicked="create" />
      </div>
      <div slot="content-main">
        <b-tabs v-model="tabIndex">
          <b-tab title="Transferências">
            <ListViewWithDataHandler :templateList="templateList" :actions="actions" :propsParam="{ ...propsParam }" />
          </b-tab>
          <b-tab title="Auditoria" v-if="userLogged.user.userName === 'UserTemp' || hasRule('Audit')">
            <TimelineLog v-if="tabIndex == 1" :id="'6cfdaaaf-2487-4760-82ba-38b9cb5c2' + userLogged.companyId" />
          </b-tab>
        </b-tabs>
      </div>
    </Panel>
    <Modal title="Transferência" :width="900" v-show="showModal('transferCreateUpdate')">
      <TransferAccountCreateUpdate />
    </Modal>
  </div>
</template>

<script>


import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel.vue";
import ListViewWithDataHandler from "@nixweb/nixloc-ui/src/component/template/ListViewWithDataHandler.vue";

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import TimelineLog from '../../../components/modules/adm/audit-log/TimelineLog.vue'
import TransferAccountCreateUpdate from '../../../components/modules/finance/transfer-account/TransferAccountCreateUpdate.vue'

import { mapGetters, mapMutations, mapActions, mapState } from "vuex";

export default {
  name: "TransferAccountView",
  components: {
    Panel,
    ListViewWithDataHandler,
    Button,
    Modal,
    TimelineLog,
    TransferAccountCreateUpdate,
  },
  data() {
    return {
      id: "",
      panel: {
        module: "Financeiro",
        title: "Transferências entre Contas",
        showFilter: true,
        showSearch: true,
        showButtons: true,
      },
      templateList: {
        urlGetApi: "/api/v1/finance/transfer-account/get-all",
        urlDeleteAllApi: "/api/v1/finance/transfer-account/delete",
        showChecks: true,
        headerTable: [
          {
            title: "Data",
            field: "date",
            type: "text",
            iconSearch: false,
          },
          {
            field: "bankAccountUrlFrom",
            container: "nixloc-bank-logo",
            type: "image",
            classCssBody: "img-bank",
          },
          {
            field: "bankAccountNameFrom",
            title: "Conta Origem",
            type: "link",
            eventName: "transferUpdate",
          },
          {
            field: "bankAccountUrlTo",
            container: "nixloc-bank-logo",
            type: "image",
            classCssBody: "img-bank",
          },
          {
            field: "bankAccountNameTo",
            title: "Conta Destino",
            type: "link",
            eventName: "transferUpdate",
          },
          {
            title: "Descrição",
            field: "description",
            type: "text",
            iconSearch: true,
          },
          {
            title: "Valor",
            field: "value",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            type: "currency",
          },
          {
            type: "button",
            field: "statusName",
            ifFieldEqual: "Gerada",
            typeButton: "default",
            button: {
              classIcon: "fa-regular fa-ban",
              type: "danger",
              size: "small",
              eventName: "cancelInvoice",
            },
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/finance/transfer-account/delete", method: "delete", },
      ],
      tabIndex: 0,
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("user", ["userLogged"]),
    ...mapGetters("user", ["hasRule"]),
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "addEvent", "removeLoading"]),
    ...mapActions("generic", ["deleteAllApi"]),
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "transferCreate") {
          this.openModal("transferCreateUpdate");
          this.addEvent({ name: "btnTransferCreate" });
          this.removeLoading(["btnTransferCreate"]);
        }

        if (event.name == "transferUpdate") this.openModal("transferCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
